import { BLACK, DARK_GREY, GREY, SCOUT_TEAL, WHITE } from '../../../ThemeContext/constants';
import { theme } from '../../../ThemeContext/ThemeObject';
import {
  centeredModalSurfaceStyles,
  compactPrimaryButtonFixedWidthStyles,
  createZoomSliderStyles,
  modalPrimaryButtonPaddedStyles
} from '../../shared/commonStyles';
import { closeIcon, copyButton as sharedCopyButton } from '../../shared/styleClasses';


export const classes = {
  // Generic dialog
  dialog: {
    padding: '40px 60px',
    alignItems: 'center',
    textAlign: 'center',
    '& > h4': {
      fontSize: '26px',
      color: theme.palette.primary.main,
      marginBottom: '14px'
    },
    '& > span': {
      fontWeight: '600',
      color: DARK_GREY,
      fontSize: '16px',
      lineHeight: '20px'
    },
    '& button:focus': {
      outline: '0'
    }
  },
  dialogButtonContainer: {
    display: 'flex',
    marginTop: '40px',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    '& > button': {
      margin: '0 10px',
      minWidth: '140px'
    }
  },
  dialogHeader: {
    color: '#727272',
    fontSize: '26px',
    fontWeight: '800',
    marginBottom: '1.5rem'
  },
  confirmationButton: {
    ...modalPrimaryButtonPaddedStyles,
    whiteSpace: 'nowrap'
  },
  tickWrapper: {
    background: SCOUT_TEAL,
    borderRadius: '5rem',
    height: '3.75rem',
    width: '3.75rem',
    display: 'flex',
    boxShadow: '2px 2px 5px #DDDDDD',
    marginBottom: '1.5rem'
  },
  crossWrapper: {
    background: theme.palette.error.main,
    borderRadius: '5rem',
    height: '3.75rem',
    width: '3.75rem',
    display: 'flex',
    boxShadow: '2px 2px 5px #DDDDDD',
    marginBottom: '1.5rem'
  },
  tickGreen: {
    color: WHITE,
    fontSize: '2.5rem',
    display: 'flex',
    margin: 'auto'
  },
  crossRed: {
    color: WHITE,
    fontSize: '2.5rem',
    display: 'flex',
    margin: 'auto'
  },
  buttonSecondaryLight: {
    borderRadius: '6px',
    fontFamily: 'Source Sans Pro',
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    padding: '14px 30px',
    fontSize: '15px',
    fontWeight: 'bold',
    background: theme.palette.secondary.light,
    color: theme.palette.secondary.main,
    '&:hover': {
      background: theme.palette.secondary.main,
      color: WHITE
    }
  },
  buttonRed: {
    borderRadius: '6px',
    fontFamily: 'Source Sans Pro',
    textTransform: 'capitalize',
    padding: '14px 30px',
    color: WHITE,
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    fontSize: '15px',
    background: theme.palette.error.main,
    '&:hover': {
      background: theme.palette.error.dark,
      color: WHITE
    }
  },
  // File Preview Modal
  imagePreview: {
    objectFit: 'contain',
    transition: 'opacity 0.3s linear'
  },
  imagePreviewContainer: {
    display: 'inline-block',
    overflow: 'auto'
  },
  previewLoader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '250px',
    rowGap: '18px',
    fontFamily: 'Source Sans Pro',
    fontSize: '18px',
    fontWeight: 'bold',
    color: theme.palette.action.main
  },
  absoluteLoader: {
    position: 'absolute',
    top: '0px'
  },
  downloadButton: compactPrimaryButtonFixedWidthStyles,
  noPreview: {
    fontFamily: 'Source Sans Pro',
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#999999',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%'
  },
  pdfPage: {
    border: '1px solid #ccc',
    boxShadow: '4px 5px 3px 0px #CCCCCC',
    marginBottom: '14px'
  },
  mediaContentContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%'
  },
  attachmentPreviewModal: {
    ...centeredModalSurfaceStyles,
    display: 'flex',
    flexDirection: 'column',
    padding: '60px',
    width: '900px',
    height: '84vh',
    dropShadow: '0px 2px 14px #305A6F29'
  },
  attachmentPreviewTitle: {
    fontFamily: 'Source Sans Pro',
    fontSize: '30px',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    display: 'flex',
    flexDirection: 'column'
  },
  attachmentPreviewContent: {
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    overflow: 'auto',
    marginTop: '36px'
  },
  attachmentPreviewActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '30px',
    width: '100%',
    columnGap: '16px',
    '& a': {
      '&:hover': {
        textDecoration: 'none'
      }
    }
  },
  closeIcon,
  fileLinkContainer: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '15px',
    '& a': {
      color: '#333333',
      fontSize: '15px',
      '&:hover': {
        color: BLACK,
        textDecoration: 'none'
      }
    }
  },
  copyButton: {
    ...sharedCopyButton,
    fontSize: '10px'
  },
  docPreviewNavigation: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: '16px'
  },
  docPreviewContent: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflowY: 'auto'
  },
  downloadModalContent: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    rowGap: '20px',
    justifyContent: 'center',
    color: theme.palette.primary.main
  },
  downloadModalDescription: {
    fontFamily: 'Source Sans Pro',
    fontSize: '17px',
    color: GREY,
    width: '100%'
  },
  primaryButtonAlternateColor: {
    color: WHITE,
    backgroundColor: SCOUT_TEAL,
    '&:hover': {
      backgroundColor: '#4da8a4',
      boxShadow: 'none'
    }
  },
  secondaryButtonAlternateColor: {
    backgroundColor: '#5BC4BF1F',
    '&:hover': {
      backgroundColor: '#5BC4BF35',
      border: 'none'
    }
  },
  zoomSlider: createZoomSliderStyles(theme.palette.secondary.main),
  zoomSliderContainer: {
    alignSelf: 'flex-end',
    marginTop: theme.spacing(1.5),
    alignItems: 'center'
  },
  zoomIcons: {
    minWidth: 'auto',
    padding: 0
  },
  felixZoomSlider: createZoomSliderStyles('#7A8EF1')
};
